import type { EvidenceActivityDir } from "../../types/evidenceActivity";

export type SortValue = string | number | null;

// Nulls sit last whichever way the list runs.
export function compareNullsLast(a: SortValue, b: SortValue, dir: EvidenceActivityDir): number {
  if (a === null || b === null) return a === b ? 0 : a === null ? 1 : -1;
  const cmp = typeof a === "number" && typeof b === "number" ? a - b : String(a).localeCompare(String(b));
  return dir === "asc" ? cmp : -cmp;
}

export function winRate(row: { won: number; lost: number }): number | null {
  const decided = row.won + row.lost;
  return decided ? row.won / decided : null;
}
